import React from "react";
import { Bar } from 'react-chartjs-2';
import { BarChart3 } from "lucide-react";
import tinycolor from "tinycolor2";
import { useTheme } from "../../CommonComponents/ThemeProvider";

const TopProduct = ({ topProductsChart }) => {
    const { currentTheme } = useTheme();
    const themedChart = {
        ...topProductsChart,
        datasets: (topProductsChart?.datasets || []).map((dataset) => ({
            ...dataset,
            backgroundColor: tinycolor(currentTheme.color).setAlpha(0.18).toRgbString(),
            borderColor: currentTheme.color,
            borderWidth: 1.5,
            borderRadius: 8,
        })),
    };

    return (
    <section className="flex w-full flex-col rounded-[30px] border border-slate-200 bg-white p-5 shadow-[0_24px_70px_rgba(15,23,42,0.08)]">
        <div className="mb-4">
            <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
                <BarChart3 className="h-4 w-4" />
                Product Ranking
            </div>
            <h2 className="mt-3 text-xl font-semibold tracking-tight text-slate-950">Top 10 Products</h2>
        </div>
        <div className="h-80 w-full rounded-[24px] border border-slate-100 bg-slate-50/50 p-3">
            <Bar data={themedChart} options={{
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    title: { display: false },
                },
                scales: {
                    x: {
                        title: { display: true, text: 'Product', font: { size: 12 }, color: '#64748b' },
                        ticks: { font: { size: 12 }, color: '#64748b' },
                        grid: { display: false },
                    },
                    y: {
                        title: { display: true, text: 'Quantity Sold', font: { size: 12 }, color: '#64748b' },
                        ticks: { font: { size: 12 }, color: '#64748b' },
                        grid: { color: '#f1f5f9' },
                    },
                },
            }} />
        </div>
    </section>
    );
};

export default TopProduct;
